import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import classnames from 'classnames';
import BreadCrumb from '../../../components/BreadCrumb';
import LoadingPlaceholder from '../../../components/LoadingPlaceholder';
import Link from '../../../components/SEO/Link';
import { getConfig } from '../../../config/portal';
import get from 'lodash/get';
import { BREAKPOINTS } from '../../../utils/commonHelper';
import { listingPropTypes } from '../../../utils/commonPropTypes';
import { getPrice, getTitle, getLocation } from '../../../utils/listingHelper';

import './styles.css';
import { nextPreviousMessages } from '../utils/breadcrumb';
import { getMessages } from '../../../tppServices/translations/messages';

class NextPrevious extends PureComponent {
  trackGenericClick = (buttonName) => () =>
    this.props.tracking.setGenericEvent(
      'navigation interaction',
      'button click',
      buttonName
    );

  getDefaultCurrency() {
    const currentLocale = get(this.props, 'intl.locale', null);
    const currencyCode = get(
      getConfig(),
      `languages.${currentLocale}.currency.abbr`,
      null
    );
    return {
      currency: get(
        getConfig(),
        `supportedCurrencies.${currencyCode}`,
        undefined
      ),
      formatingOptions: get(
        getConfig(),
        `languages.${currentLocale}.currency.format`,
        undefined
      )
    };
  }

  render() {
    const {
      listing,
      breadCrumbs,
      intl: { formatMessage: t },
      isLoading,
      navLinks,
      showInfo,
      breakpoint,
      longNextPrevious
    } = this.props;
    const { next, previous, searchUrl } = navLinks;
    const isDesktop = breakpoint === BREAKPOINTS.desktop;
    const messages = getMessages();
    const { nextBoat, prevBoat, search } = nextPreviousMessages(
      t,
      messages,
      isDesktop,
      longNextPrevious
    );
    const hidden = !previous && !next && !isDesktop;

    return (
      <>
        <div className={classnames('next-previous-spacer', { hidden })}></div>
        <div
          className={classnames('next-previous', {
            'show-info': showInfo,
            hidden
          })}
        >
          {searchUrl && (
            <Link
              className="next-previous-button next-previous-search"
              href={searchUrl}
              onClick={this.trackGenericClick('back to search')}
            >
              {search}
            </Link>
          )}
          {isDesktop && (
            <div className="next-previous-info-container">
              {isLoading && <LoadingPlaceholder type="text" />}
              <BreadCrumb items={breadCrumbs} />
              {!isLoading && listing.id && (
                <div className="next-previous-info">
                  <div className="next-previous-listing-name">
                    {getTitle(listing)}
                  </div>
                  <div className="next-previous-listing-price">
                    {getPrice(listing, this.getDefaultCurrency())}
                  </div>
                  <div className="next-previous-listing-location">
                    {getLocation(listing)}
                  </div>
                </div>
              )}
            </div>
          )}
          <div
            className={classnames('next-previous-button-tray', {
              'no-next-previous': !previous && !next
            })}
          >
            {previous && (
              <Link
                className="next-previous-button next-previous-prev"
                href={previous}
                onClick={this.trackGenericClick('previous product')}
              >
                {prevBoat}
              </Link>
            )}
            {next && (
              <Link
                className="next-previous-button next-previous-next"
                href={next}
                onClick={this.trackGenericClick('next product')}
              >
                {nextBoat}
              </Link>
            )}
          </div>
        </div>
      </>
    );
  }
}

NextPrevious.defaultProps = {
  listing: {},
  navLinks: {},
  showInfo: false
};

NextPrevious.propTypes = {
  breadCrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      link: PropTypes.string,
      title: PropTypes.string,
      type: PropTypes.string
    })
  ),
  breakpoint: PropTypes.oneOf(Object.keys(BREAKPOINTS)),
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired
  }).isRequired,
  isLoading: PropTypes.bool,
  /** Current listing */
  listing: listingPropTypes,
  /** Links to next, previous, and back to search */
  navLinks: PropTypes.shape({
    next: PropTypes.string,
    previous: PropTypes.string,
    searchUrl: PropTypes.string
  }),
  /** Display listing information */
  showInfo: PropTypes.bool,
  /** Analytics tracking helper */
  tracking: PropTypes.shape({
    setGenericEvent: PropTypes.func.isRequired
  }).isRequired,
  longNextPrevious: PropTypes.bool
};

export default injectIntl(NextPrevious);
